import React, { Component } from 'react'

import { Task, Ownership, FraudCheck } from '../types'
import { Vehicle } from '../../../core/types'

export interface Props {
  task: Task
}

export default class Registration extends Component<Props> {
  render() {
    const {
      task: {
        vehicle: {
          make,
          model,
          year,
          fraudCheck: {
            lastOwnership: {
              state,
              city,
              titlingState,
              titleNumber,
              lastOdometerMileage,
            } = {} as Ownership,
          } = {} as FraudCheck,
        } = {} as Vehicle,
      },
    } = this.props

    return (
      <div>
        <div className="task-registration__col2">
          <div className="task-registration__info-header">
            <div className="task-registration__info-header__row">Year</div>
            <div className="task-registration__info-header__row">Make</div>
            <div className="task-registration__info-header__row">Model</div>
            <div className="task-registration__info-header__row">
              Last acquisition state
            </div>
            <div className="task-registration__info-header__row">
              Last titling state
            </div>
            <div className="task-registration__info-header__row">
              Title number
            </div>
            <div className="task-registration__info-header__row">
              Last owner location
            </div>
            <div className="task-registration__info-header__row">
              Last odometer reading
            </div>
          </div>
          <div className="task-registration__info-block">
            <div className="task-registration__info-block__row">
              {year ? year : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {make ? make : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {model ? model : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {state ? state : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {titlingState ? titlingState : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {titleNumber ? titleNumber : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {city && titlingState ? `${city}, ${titlingState}` : 'N/A'}
            </div>
            <div className="task-registration__info-block__row">
              {lastOdometerMileage ? lastOdometerMileage : 'N/A'}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
